import { render, staticRenderFns } from "./TrainingPrograms.vue?vue&type=template&id=66d0f5e6&scoped=true"
import script from "./TrainingPrograms.vue?vue&type=script&lang=js"
export * from "./TrainingPrograms.vue?vue&type=script&lang=js"
import style0 from "./TrainingPrograms.vue?vue&type=style&index=0&id=66d0f5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0f5e6",
  null
  
)

export default component.exports